import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ArrowLeft } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const PageHeader = ({ title }) => {
  const { t } = useTranslation(['eventManagement'])
  const navigate = useNavigate()

  return (
    <div className="event-management_page-header">
      <button
        type="button"
        className="button button-transparent"
        onClick={() => navigate('/dashboard/calendar')}
      >
        <ArrowLeft size={20} />
        {t('eventManagement:common.back')}
      </button>
      <h1>{title}</h1>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
}

export default PageHeader
